import React, { useState } from "react";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import "./parciality.css";
import Swal from "sweetalert2";
import { FaTimes, FaPlus, FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { createRoot } from "react-dom/client";
import axios from "axios";
import ContenedoresActivos from "./contentAcvites";
import { Modal, Spinner } from "react-bootstrap";

function Parciality({ masterNumber, dataMaster, onBack }) {
  const {
    master,
    houses,
    exp_invoices,
    merchandise_types,
    booking_flights

  } = dataMaster;

  const [formErrors, setFormErrors] = useState({});
  const [housesState, setHousesState] = useState(houses);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    master: master.master,
    origenInicial: master.origin,
    origen: master.final_origin,
    destino: master.destiny,
    destinoFinal: master.final_destination,
    piezas: master.is_completed ? master.pieces : "",
    grossWeight: master.is_completed ? master.weight : "",
    chargeableWeight: master.is_completed ? master.chargeable_weight : "",
    volumen: master.is_completed ? master.volume : "",
    tipo: master.merchandise_type,
    descripcion: master.description,
  });
  const [loading, setLoading] = useState(false);

  const handleRedirectToPreCapture = () => {
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    if (formErrors[field]) {
      setFormErrors({ ...formErrors, [field]: "" });
    }
  };

  const guardarAlert = async () => {
     setLoading(true);
    const errors = {};
    const requiredFields = [
      "origenInicial",
      "origen",
      "piezas",
      "destino",
      "destinoFinal",
      "grossWeight",
      "chargeableWeight",
      "volumen",
      "tipo",
      "descripcion",
    ];


    // Validar campos individuales del formulario
    requiredFields.forEach((field) => {
      // Verificar si el campo es editable
      const isAlwaysReadOnly = field === "master"; // ejemplo, ajusta según tu lógica
      const isConditionalReadOnly =
        ["piezas", "grossWeight", "chargeableWeight", "volumen"].includes(field) &&
        !master.is_completed;

      const isReadOnly = isAlwaysReadOnly || isConditionalReadOnly;

      // Solo validar si NO está bloqueado
      if (!isReadOnly && (!formData[field] || formData[field].toString().trim() === "")) {
        errors[field] = "Este campo es obligatorio";
      }
    });

    if (Object.keys(errors).length > 0) {
      setLoading(false);
      setFormErrors(errors); // esto debería usarse en los inputs del form
      Swal.fire({
        title: "Faltan datos",
        text: "Por favor, completa todos los campos obligatorios.",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    const fieldMap = {
      origenInicial: "origin",
      origen: "final_origin",
      piezas: "pieces",
      destino: "destiny",
      destinoFinal: "final_destination",
      grossWeight: "weight",
      chargeableWeight: "chargeable_weight",
      volumen: "volume",
      tipo: "merchandise_type",
      descripcion: "description",
      // agrega aquí los demás campos que necesites renombrar
    };

    // Crear objeto final con nombres correctos
    const datosFinales = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        fieldMap[key] || key,
        value,
      ])
    );


    //Aqui iria la logica para guardar los datos

    const house_id = Array.from(document.querySelectorAll("input[name='house_id[]']"))
      .map(input => input.value);

    const house_hbs = Array.from(document.querySelectorAll("input[name='house_hbs[]']"))
      .map(input => input.value);

    const house_pieces = Array.from(document.querySelectorAll("input[name='house_pieces[]']"))
      .map(input => input.value);

    const house_gross_weight = Array.from(document.querySelectorAll("input[name='house_gross_weight[]']"))
      .map(input => input.value);

    const house_chargeable_weight = Array.from(document.querySelectorAll("input[name='house_chargeable_weight[]']"))
      .map(input => input.value);

    const house_volume = Array.from(document.querySelectorAll("input[name='house_volume[]']"))
      .map(input => input.value);

    const house_description = Array.from(document.querySelectorAll("input[name='house_description[]']"))
      .map(input => input.value);

    const house_merchandise_type = Array.from(document.querySelectorAll("input[name='house_merchandise_type_id[]']"))
      .map(input => input.value);

    const parcial_pieces = house_pieces.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );
    const parcial_gross = house_gross_weight.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );
    const parcial_chargeable = house_chargeable_weight.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );

    const pieces_master = Number(formData.piezas || 0);
    const gross_master = Number(formData.grossWeight || 0);
    const chargeable_master = Number(formData.chargeableWeight || 0);

    let errorMsg = [];
    let flag = false;

    // Validaciones
    if (pieces_master < parcial_pieces) {
      errorMsg.push(
        "Las piezas de la master no pueden ser menor a la suma de las piezas de las houses, favor de verificar"
      );
      flag = true;
    }
    if (gross_master < parcial_gross) {
      errorMsg.push(
        "El gross weight de la master no puede ser menor a la suma de las houses, favor de verificar"
      );
      flag = true;
    }
    if (chargeable_master < parcial_chargeable) {
      errorMsg.push(
        "El chargeable weight de la master no puede ser menor a la suma de las houses, favor de verificar"
      );
      flag = true;
    }

    // Mostrar alerta si hubo errores
    if (flag) {
      setLoading(false);
      setError(errorMsg);
      return;
    }
    setError([]);

    const house_flight = [];
    const house_year = [];
    const house_time = [];

    housesState.forEach((house) => {
      const vuelosValidos = house.editedFlights?.length
        ? house.editedFlights
        : booking_flights.filter(f => f.exp_house_id === house.id);

      // Filtramos vuelos válidos
      const vuelosFiltrados = vuelosValidos.filter(f => f.flight && f.year && f.time);

      if (vuelosFiltrados.length > 0) {
        // Concatenar en un string separado por coma
        const vuelosConcatenados = vuelosFiltrados.map(f => f.flight).join(",");
        const yearsConcatenados = vuelosFiltrados.map(f => f.year).join(",");
        const timesConcatenados = vuelosFiltrados.map(f => f.time).join(",");

        house_flight.push(vuelosConcatenados);
        house_year.push(yearsConcatenados);
        house_time.push(timesConcatenados);
      } else {
        // Si no hay vuelos, agregamos string vacío
        house_flight.push("");
        house_year.push("");
        house_time.push("");
      }
    });

    datosFinales.house_id = house_id;
    datosFinales.house_hbs = house_hbs;
    datosFinales.house_pieces = house_pieces;
    datosFinales.house_gross_weight = house_gross_weight;
    datosFinales.house_chargeable_weight = house_chargeable_weight;
    datosFinales.house_volume = house_volume;
    datosFinales.house_description = house_description;
    datosFinales.house_merchandise_type = house_merchandise_type;
    datosFinales.house_flight = house_flight;
    datosFinales.house_time = house_time;
    datosFinales.house_year = house_year;
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    datosFinales.master_id = master.id;
    datosFinales.user_id = user_id;
    const params = datosFinales;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/upd_save/3`,
        params,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.error === false) {
        setLoading(false);
        Swal.fire({
          title: "Guardado",
          text: "Los datos han sido guardados correctamente.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  const eliminarAlert = () => {
    Swal.fire({
      title: `¿Quieres eliminar la master ${master.master}?`,
      text: "",
      html: '<div class="alert-text">Esta acción es irreversible</div>',
      iconColor: "#ED1B1B",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "alert-bg",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {

      if (result.isConfirmed) {
        setLoading(true);
        const params = {
          master_id: master.id,
        };

        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/delete_exp_master`,
            {
              params: params,
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
              },
            }
          );

          if (response.data.error === false) {
            setLoading(false);
            Swal.fire({
              title: "¡Eliminado!",
              text: `${response.data.body.message}`,
              icon: "success",
              iconColor: "#1B9925",
              customClass: {
                confirmButton: "btn-ok",
                title: "alert-title",
                popup: "alert-bg",
              },
            }).then(() => {
              onBack(); 
            });
          }
        } catch (error) {
          setLoading(false);
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        }
      }
    });
  };

  const editarAlert = (house) => {
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from(
      { length: currentYear - 2019 + 2 },
      (_, i) => 2019 + i
    );

    const merchandiseOptions = dataMaster.merchandise_types
      .map(
        (type) =>
          `<option value="${type.id}" ${type.id === house.merchandise_type_id ? "selected" : ""}>${type.name}</option>`
      )
      .join("");

    // Filtrar vuelos correspondientes a la house seleccionada
    const vuelosHouse = house.editedFlights || booking_flights.filter(f => f.exp_house_id === house.id);

    Swal.fire({
      title: "Editar Datos",
      html: `
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">HBS</label>
              <input id="hbs" class="form-control" value="${house.hbs}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Piezas</label>
              <input id="piezas" type="text" min="0" step="1" oninput="this.value=this.value.replace(/[^0-9]/g,'')" class="form-control" value="${house.pieces}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Gross Weight</label>
              <input id="grossWeight" class="form-control" type="text" step="0.01" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.gross_weight}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Chargeable Weight</label>
              <input id="chargeableWeight" class="form-control" type="text" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.chargeable_weight}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Volumen</label>
              <input id="volumen" class="form-control" type"text" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.volume}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Tipo de mercancía</label>
              <select id="tipo" class="form-select">
                ${merchandiseOptions}
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Descripción</label>
              <textarea id="descripcion" class="form-control" rows="2">${house.description}</textarea>
            </div>
          </div>
  
          <div style="margin-top: 1rem; width: 100%;">
            <table id="dynamicTable" class="table fondo-headUPD text-center">
              <thead class="table-light">
                <tr>
                  <th>* Vuelo</th>
                  <th>* Año</th>
                  <th>* Hora Vuelo</th>
                  <th>Eliminar</th>
                </tr>
              </thead>
              <tbody id="tableBody"></tbody>
            </table>
            <div class="text-center">
              <button type="button" id="addRowBtn" class="btn btn-sm btn-dark">
                <span id="plusIcon"></span>
              </button>
            </div>
                      <div class="col-12 mb-2">
      <div id="error-normal" class="text-danger mt-2 alert alert-danger text-left d-none"></div>
    </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "form-alert-popup",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
      },
      didOpen: () => {
        const escapeHtml = (unsafe) => {
          if (unsafe == null) return "";
          return String(unsafe)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
        };

        const plusIcon = document.getElementById("plusIcon");
        if (plusIcon) createRoot(plusIcon).render(<FaPlus style={{ color: "white" }} />);

        const tableBody = document.getElementById("tableBody");
        const addRowBtn = document.getElementById("addRowBtn");

        if (!tableBody || !addRowBtn) return;

        // Función para agregar fila (puede recibir datos iniciales)
        const addRow = (flight = { vuelo: "", anio: currentYear, hora: "00:00" }) => {
          const row = document.createElement("tr");
          const uid = `trash-${Date.now()}`;

          row.innerHTML = `
            <td><input type="text" class="form-control form-control-sm text-center flight-input" name="house_flight[]" value="${escapeHtml(flight.vuelo)}" /></td>
            <td>
              <select class="form-select form-select-sm" name="house_year[]">
                ${yearOptions.map(y => `<option value="${y}" ${y === flight.anio ? "selected" : ""}>${y}</option>`).join("")}
              </select>
            </td>
            <td><input type="time" class="form-control form-control-sm text-center" name="house_time[]" value="${escapeHtml(flight.hora)}" /></td>
            <td>
              <button type="button" class="btn btn-white btn-sm deleteRowBtn">
                <span id="${uid}"></span>
              </button>
            </td>
          `;

          tableBody.appendChild(row);

          // Renderizar ícono de basura
          const trashIcon = document.getElementById(uid);
          if (trashIcon) createRoot(trashIcon).render(<FaTrashAlt style={{ color: "red" }} />);

          row.querySelector(".deleteRowBtn").addEventListener("click", () => row.remove());
          
          const flightInput = row.querySelector(".flight-input");

          flightInput.addEventListener("input", (e) => {
            e.target.value = e.target.value.toUpperCase(); // solo mayúsculas
          });
        
          // Formatea al salir
          flightInput.addEventListener("blur", (e) => {
            let value = e.target.value.toUpperCase();
            if (!value) return;
        
            let data = value.split("/");
            let prefix = data[0].substring(0, 2);
            let rest = data[0].substring(2);
        
            if (prefix === "AM") {
              if (rest.length === 1) rest = "000" + rest;
              else if (rest.length === 2) rest = "00" + rest;
              else if (rest.length === 3) rest = "0" + rest;
              else if (rest.length >= 4) rest = rest.substring(0, 4);
        
              const flightFormatted = "AM" + rest;
        
              if (data[1] === undefined || data[1] === "") {
                value = `${flightFormatted}/`;
              } else {
                value = `${flightFormatted}/${data[1]}`;
              }
            }
        
            e.target.value = value;
          });
        };

        // Agregar filas existentes de vuelos


        vuelosHouse.forEach(f => addRow({ vuelo: f.flight, anio: f.year || currentYear, hora: f.time || "00:00" }));
        addRowBtn.addEventListener("click", () => addRow());
      },
      preConfirm: () => {
        const formValues = {
          hbs: document.getElementById("hbs").value,
          piezas: document.getElementById("piezas").value,
          grossWeight: document.getElementById("grossWeight").value,
          chargeableWeight: document.getElementById("chargeableWeight").value,
          volumen: document.getElementById("volumen").value,
          tipo: document.getElementById("tipo").value,
          descripcion: document.getElementById("descripcion").value,
          vuelos: [],
        };

        document.querySelectorAll("#tableBody tr").forEach((tr) => {
          const flight = tr.children[0].querySelector("input").value;
          const year = tr.children[1].querySelector("select").value;
          const time = tr.children[2].querySelector("input").value;
          formValues.vuelos.push({ flight, year, time });
        });

        const errorDiv = document.getElementById("error-normal");

        for (const [key, value] of Object.entries(formValues)) {
          if (!value) {
            errorDiv.textContent = `El campo "${key}" es obligatorio`;
            errorDiv.classList.remove("d-none");
            return false; // detiene el modal hasta que se corrija
          }
        }

        const parcial_pieces = Number(formValues.piezas);
        const parcial_gross = Number(formValues.grossWeight);
        const parcial_chargeable = Number(formValues.chargeableWeight);

        const noCommas = (value) => value.replace(/,/g, "");

        const pieces_master = master.pieces
          ? parseInt(noCommas(master.pieces))
          : 999999999;
        const gross_master = master.weight
          ? parseInt(noCommas(master.weight))
          : 999999999
        const chargeable_master = master.chargeable_weight
          ? parseInt(noCommas(master.chargeable_weight))
          : 999999999

        // Validaciones
        if (pieces_master < parcial_pieces) {
          errorDiv.textContent =
            "Las piezas de la master no pueden ser menor a la suma de las piezas de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }
        if (gross_master < parcial_gross) {
          errorDiv.textContent =
            "El gross weight de la master no puede ser menor a la suma de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }
        if (chargeable_master < parcial_chargeable) {
          errorDiv.textContent =
            "El chargeable weight de la master no puede ser menor a la suma de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }

        // --- VALIDAR vuelos DESPUÉS de agregarlos ---
        if (formValues.vuelos.length === 0) {
          errorDiv.textContent = "Debes agregar al menos un vuelo";
          errorDiv.classList.remove("d-none");
          return false;
        }

        const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        for (let i = 0; i < formValues.vuelos.length; i++) {
          const vuelo = formValues.vuelos[i]; // el objeto { flight, year, time }
          const flightStr = vuelo.flight || ""; // aseguramos que sea string

          // Verificamos que tenga el formato "XXX/12JAN"
          const flight = flightStr.split('/');
          if (flight.length < 2) {
            errorDiv.textContent = `El vuelo "${flightStr}" tiene formato incorrecto (ejemplo: ABC/12JAN)`;
            errorDiv.classList.remove("d-none");
            return false;
          }

          const day = flight[1].substring(0, 2);
          const month = flight[1].substring(2, 5).toUpperCase();

          if (isNaN(day)) {
            errorDiv.textContent = `El día del vuelo "${flightStr}" no es un número válido`;
            errorDiv.classList.remove("d-none");
            return false;
          }

          if (!months.includes(month)) {
            errorDiv.textContent = `El mes del vuelo "${flightStr}" no es válido. Usa JAN, FEB, MAR, etc.`;
            errorDiv.classList.remove("d-none");
            return false;
          }
        }


        return formValues;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Guardar los cambios directamente en el objeto house
        setHousesState(prev =>
          prev.map(h =>
            h.id === house.id
              ? {
                ...h,
                hbs: result.value.hbs,
                pieces: result.value.piezas,
                gross_weight: result.value.grossWeight,
                chargeable_weight: result.value.chargeableWeight,
                volume: result.value.volumen,
                merchandise_type_id: Number(result.value.tipo),
                description: result.value.descripcion,
                editedFlights: result.value.vuelos,
              }
              : h
          )
        );
      }
    });
  };


  const deleteAlert = () => {
    Swal.fire({
      title: "¿Seguro que desea eliminar la house?",
      html: '<div class="alert-text">Esta acción es irreversible al dar clic en Aceptar, ¿Deseas continuar?</div>',
      iconColor: "#ED1B1B",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "alert-bg custom-width",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "¡Eliminado!",
          text: "La house fue eliminado.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <>
          <div className="row mb-3">
            <div className="col-12 text-end">

              {Number(formData.tipo) === 19 ? (
                <ContenedoresActivos id={dataMaster.master.id} />
              ) : ""}

              <button
                className="btn btn-amc-pink botonEliminar"
                onClick={eliminarAlert}
              >
                Eliminar guía
              </button>
            </div>
          </div>

          {/* inputs y selects */}
          <div className="row mb-4">
            {[
              { label: "Master", key: "master" },
              { label: "Origen inicial", key: "origenInicial" },
              { label: "Origen", key: "origen" },
              { label: "Destino", key: "destino" },
              { label: "Destino final", key: "destinoFinal" },
              { label: "Piezas Master", key: "piezas" },
              { label: "Gross Weight Master", key: "grossWeight" },
              { label: "Chargeable Weight Master", key: "chargeableWeight" },
              { label: "Volumen Master", key: "volumen" },
              { label: "Tipo de mercancia", key: "tipo" },
              { label: "Descripción Master", key: "descripcion" },
            ].map((item, index) => {
              const isAlwaysReadOnly = [0].includes(index);
              const isConditionalReadOnly =
                ["piezas", "grossWeight", "chargeableWeight", "volumen"].includes(item.key)
                && !master.is_completed; // solo editables si está completado

              const isReadOnly = isAlwaysReadOnly || isConditionalReadOnly;
              return (
                <div key={index} className="col-md-4 mb-3">
                  <label className="form-label fw-bold">{item.label}</label>

                  {item.key === "tipo" ? (
                    <>
                      <select
                        className="form-select"
                        value={formData.tipo}
                        onChange={(e) => handleInputChange("tipo", e.target.value)}
                      >
                        {merchandise_types.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                      {formErrors.tipo && (
                        <small className="text-danger">{formErrors.tipo}</small>
                      )}
                    </>
                  ) : item.key === "descripcion" ? (
                    <>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={formData.descripcion}
                        onChange={(e) =>
                          handleInputChange("descripcion", e.target.value)
                        }
                      />
                      {formErrors.descripcion && (
                        <small className="text-danger">
                          {formErrors.descripcion}
                        </small>
                      )}
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className={`form-control ${isReadOnly ? "fondoInput" : ""
                          }`}
                        readOnly={isReadOnly}
                        value={formData[item.key]}
                        maxLength={["origenInicial", "origen", "destino", "destinoFinal"].includes(item.key) ? 3 : undefined}
                        onChange={(e) => {
                          const value = e.target.value;

                          if (item.key === "piezas") {
                            if (/^\d*$/.test(value)) {
                              handleInputChange("piezas", value);
                            }
                          } else if (
                            ["grossWeight", "chargeableWeight", "volumen"].includes(
                              item.key
                            )
                          ) {
                            if (/^\d*\.?\d*$/.test(value)) {
                              handleInputChange(item.key, value);
                            }
                          } else if (
                            ["origenInicial", "origen", "destino", "destinoFinal"].includes(
                              item.key
                            )
                          ) {
                            const upper = value.toUpperCase();
                            if (/^[A-Z]{0,3}$/.test(upper)) {
                              handleInputChange(item.key, upper);
                            }
                          } else {
                            handleInputChange(item.key, value);
                          }
                        }}
                      />
                      {formErrors[item.key] && (
                        <small className="text-danger">
                          {formErrors[item.key]}
                        </small>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>

          {!master.is_completed && (
            <div className="col-md-12 mt-2 mb-2">
              <div className="alert alert-warning">
                La master no ha sido cerrada, no será posible editar piezas, peso y volumen hasta que se cierre
              </div>
            </div>
          )}

          {master.entry_date && (
            <div className="col-md-12 mt-2 mb-2">
              <div class="alert alert-warning">La master ya reportó una entrada de conectividad SAT, para agregar una irregularidad, comuníquese con el proveedor dando clic en el siguiente enlace <a href="https://www.fabricadesoluciones.com/ticketing/horus/incidents-create" target="_black">"Ticketing Horus"</a></div>

            </div>
          )}

          {/* tabla */}
          <div className="row mb-4">
            <div className="col-12">
              <table className="table text-center mx-auto" style={{ maxWidth: "900px", width: "100%" }}>
                <thead className="table-light fondo-headUPD">
                  <tr style={{ fontSize: "13px" }}>
                    <th>HBS</th>
                    <th>Piezas</th>
                    <th>Gross Weight</th>
                    <th>Chargeable Weight</th>
                    <th>Volumen</th>
                    <th>Tipo de mercancia</th>
                    <th>Descripción</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {housesState?.length > 0 ? (
                    housesState.map((house) => {
                      const hasInvoice = !!exp_invoices.some(
                        (inv) => Number(inv.exp_house_id) === house.id
                      );

                      return (
                        <tr key={house.id} id={`tr_${house.id}`}>
                          <td>
                            <span id={`label_hbs_${house.id}`}>{house.hbs}</span>
                            <input type="hidden" name="house_hbs[]" value={house.hbs} />
                            <input type="hidden" name="house_id[]" value={house.id} />
                          </td>
                          <td>
                            <span id={`label_pieces_${house.id}`} className="label_pieces">
                              {house.pieces}
                            </span>
                            <input type="hidden" name="house_pieces[]" value={house.pieces} />
                          </td>
                          <td>
                            <span id={`label_gross_weight_${house.id}`} className="label_gross">
                              {house.gross_weight}
                            </span>
                            <input
                              type="hidden"
                              name="house_gross_weight[]"
                              value={house.gross_weight}
                            />
                          </td>
                          <td>
                            <span
                              id={`label_chargeable_weight_${house.id}`}
                              className="label_chargeable"
                            >
                              {house.chargeable_weight}
                            </span>
                            <input
                              type="hidden"
                              name="house_chargeable_weight[]"
                              value={house.chargeable_weight}
                            />
                          </td>
                          <td>
                            <span id={`label_volume_${house.id}`}>{house.volume}</span>
                            <input type="hidden" name="house_volume[]" value={house.volume} />
                          </td>
                          <td>
                            <span id={`label_merchandise_type_id_${house.id}`}>
                              {merchandise_types.find(m => m.id === house.merchandise_type_id)?.name || ''}

                            </span>
                            <input
                              type="hidden"
                              name="house_merchandise_type_id[]"
                              value={house.merchandise_type_id ?? ""}
                            />
                          </td>
                          <td>
                            <span id={`label_description_${house.id}`}>
                              {house.description}
                            </span>
                            <input
                              type="hidden"
                              name="house_description[]"
                              value={house.description}
                            />
                          </td>
                          <td>
                            {!hasInvoice ? (
                              <div className="d-flex justify-content-center gap-1">
                                <button
                                  className="btn-pink-secondary custom-btn"
                                  onClick={() => editarAlert(house)}
                                >
                                  <FaPencil />
                                </button>

                                <button
                                  className="btn-pink-secondary custom-btn"
                                  onClick={deleteAlert}
                                >
                                  <FaTimes />
                                </button>
                              </div>
                            ) : (
                              "Fact. activa"
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8}>No hay houses para este master</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {error.length > 0 && (
            <div className="text-danger mt-2 alert alert-danger text-left">
              <ul className="mb-0">
                {error.map((err, index) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="row mb-3">
            <div className="col text-end">
              <button className="btnn" onClick={guardarAlert}>
                Guardar
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col text-end">
              <button
                type="button"
                onClick={handleRedirectToPreCapture}
                rel="noopener noreferrer"
                className="btn p-0 m-0 botonIr"
              >
                Ir a precaptura de la guía 123-12345678
              </button>
            </div>
          </div>
        </>
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Parciality;